import { EntityStore } from "./entity-implementations";
import { LoggingService } from "../loggingSvc";
import { StoreChangeDetails, ValueContext } from "./entity-contracts";
import { RootStoreImplementation } from "./entity-root-store-implementation";
import { Observable } from "@reactivex/rxjs";
import { ServiceDeskConfig } from "../../Startup/serviceDeskConfig";

/** Entity service provide api to manage entity store and handle updates to changes to the entity
 * Entity service implementors would need to inherit and use the store provided the entity service.
 */
export class EntityServiceBase<T> {
  private static root = new RootStoreImplementation();
  protected store: EntityStore<T>;

  // @ngInject
  constructor(protected loggingService: LoggingService, protected sdConfig: ServiceDeskConfig) {}

  /**
   * Observe store for changes.
   */
  public getStoreChangesAsObservable(): Observable<StoreChangeDetails> {
    return this.store.getChangesAsObservable();
  }

  private get rootStore(): RootStoreImplementation {
    return EntityServiceBase.root;
  }

  /**
   * Get the entity value as observable, given a value observable updates the value.
   * @param key identifier of the value container.
   * @param fetchDataCallback function which is called to get the data from external service.
   * @param reason reason for creating value context
   */
  protected getValueAsObservable(
    key: string,
    fetchDataCallback?: any,
    reason?: string,
    forceUpdate?: boolean
  ): Observable<T> {
    let valueContainer = this.store.getOrAddValueContainer(key, undefined, reason, fetchDataCallback, forceUpdate);
    return valueContainer.asObservable();
  }

  /**
   * Set entity value based on the key and value context.
   * @param key identifier of the value container.
   * @param valueContext context for the value.
   */
  protected setValue(key: string, valueContext: ValueContext<T>): void {
    this.store.getOrAddValueContainer(key, valueContext);
  }

  /**
   * To be called by implementors of entity service for any change to entity state.
   * @param reason for the change.
   * @param data associated to the change.
   */
  protected onChange<TChange>(reason: string, data: TChange) {
    this.store.setValue(reason, data);
  }
}
